import fetch from 'utils/fetch';
import qs from 'querystring';
class Category {
    static getAllCategory(callback) {
        fetch({
            url: '/av1/categoryManage/getCategoryTreeByParent',
            method: 'post',
        }).then(callback);
    }

    static addCategory(category,callback){
        let data = qs.stringify(category);
        fetch({
            url: '/av1/categoryManage/addCategory',
            method: 'post',
            data
        }).then(callback);
    }

    static editCategory(category,callback){
        let data = qs.stringify(category);
        fetch({
            url: '/av1/categoryManage/editCategory',
            method: 'post',
            data
        }).then(callback);
    }

    static delCategory(cateId,callback){
        let data = qs.stringify({cateId});
        console.log(data);
        fetch({
            url: '/av1/categoryManage/delCategory',
            method: 'post',
            data
        }).then(callback);
    }
}

module.exports =  Category;


// WEBPACK FOOTER //
// ./src/api/category.js